<template>
  <component class="title-4" :is="tag">
    <slot />
  </component>
</template>

<script>
export default {
  name: "Title4App",
  props: {
    tag: {
      // Определяет возвращаемый тег, по умолчанию h3
      type: String,
      default: "h4",
    },
  },
};
</script>

<style>
.title-4 {
  font-family: 'Constantia', Tahoma, sans-serif;
  font-size: 20px;
  line-height: 1.6;
  color: #ffffff;
  font-weight: normal;
}

@media screen and (max-width: 1919.98px) {
  .title-4 {
    font-size: 18px;
  }
}

@media screen and (max-width: 1599.98px) {
  .title-4 {
    font-size: 16px;
  }
}

@media screen and (max-width: 1199.98px) {
  .title-4 {
    font-size: 14px;
  }
}
</style>
